import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import { Toaster } from './components/ui/sonner';

import Landing from './pages/Landing';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminClient from './pages/AdminClient';
import AdminSettings from './pages/AdminSettings';
import AdminGallery from './pages/AdminGallery';
import AdminSubgallery from './pages/AdminSubgallery';
import ClientLogin from './pages/ClientLogin';
import ClientHome from './pages/ClientHome';
import ClientGallery from './pages/ClientGallery';
import GalleryView from './pages/GalleryView';

const AdminOnly = ({ children }) => {
  const { admin, ready } = useAuth();
  if (!ready) return null;
  return admin ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminOnly><AdminDashboard /></AdminOnly>} />
              <Route path="/admin/clienti/:clientSlug" element={<AdminOnly><AdminClient /></AdminOnly>} />
              <Route path="/admin/clienti/:clientSlug/lavori/:gallerySlug" element={<AdminOnly><AdminGallery /></AdminOnly>} />
              <Route path="/admin/clienti/:clientSlug/lavori/:gallerySlug/sotto/:subgallerySlug" element={<AdminOnly><AdminSubgallery /></AdminOnly>} />
              <Route path="/admin/impostazioni" element={<AdminOnly><AdminSettings /></AdminOnly>} />
              <Route path="/c/:clientSlug" element={<ClientLogin />} />
              <Route path="/c/:clientSlug/home" element={<ClientHome />} />
              <Route path="/c/:clientSlug/lavori/:gallerySlug" element={<ClientGallery />} />
              <Route path="/c/:clientSlug/lavori/:gallerySlug/:subgallerySlug" element={<GalleryView />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
